import React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface ResponsiveDialogProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md';
}

/** Телефон/планшет — шторка снизу; ПК — диалог по центру. */
export const ResponsiveDialog: React.FC<ResponsiveDialogProps> = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'sm',
}) => {
  const theme = useTheme();
  const sheet = useMediaQuery(theme.breakpoints.down('lg'));

  if (sheet) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: '85vh',
            width: '100%',
            maxWidth: 720,
            mx: 'auto',
            pb: 'env(safe-area-inset-bottom)',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1.5 }}>
            <Box sx={{ width: 36, height: 4, borderRadius: 2, bgcolor: 'divider', flexShrink: 0 }} />
          </Box>
          {title && (
            <Typography variant="h4" sx={{ mb: 1 }}>
              {title}
            </Typography>
          )}
          {children}
          {actions && (
            <Box sx={{ display: 'flex', gap: 1, mt: 2, '& > *': { flex: 1, minHeight: 48 } }}>{actions}</Box>
          )}
        </Box>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth}>
      {title && <DialogTitle>{title}</DialogTitle>}
      {children && <DialogContent>{children}</DialogContent>}
      {actions && <DialogActions sx={{ p: 2, gap: 1 }}>{actions}</DialogActions>}
    </Dialog>
  );
};
